import React from 'react'
import { Button } from '@/components/ui/button'
import { useResolveLocaleField } from '@/app/[locale]/_hooks/useResolveLocaleField'
import { ICategory } from '@/app/[locale]/_types'
import { Link } from '@/i18n/navigation'
import Image from 'next/image'

export default function Desktop({
  category,
  isSeperatePage,
}: {
  category: ICategory
  isSeperatePage: boolean
}) {
  const resolveLocale = useResolveLocaleField()

  return (
    <Link
      href={
        isSeperatePage ? `/category/${category?.slug}` : `#${category?.slug}`
      }
      scroll={!isSeperatePage}
    >
      <Button
        bg='background.card'
        color='text'
        rounded={16}
        size='lg'
        h={14}
        px={4}
        gap={2}
      >
        {category?.image && (
          <Image
            width='36'
            height='32'
            style={{
              borderRadius: '16px',
              width: '36px',
              height: '32px',
              objectFit: 'cover',
            }}
            src={process.env.BASE_URL + category?.image}
            alt={resolveLocale(category?.title)}
          />
        )}
        {resolveLocale(category?.title)}
      </Button>
    </Link>
  )
}
